module.exports = __webpack_public_path__ + "static/media/code.5cac3dea.png";